import { style, query, group, animate, animateChild } from '@angular/animations';

export const slideLeftAnimation = [
  style({ position: 'relative' }),
  query(':enter, :leave', [
    style({
      position: 'absolute',
      top: 0,
      right: 0,
      width: '100%',
      height: '100%'
    })
  ], {optional: true}),
  query(':enter', [
    style({ right: '-100%' })
  ], { optional: true }),
  query(':leave', animateChild(), { optional: true }),
  group([
    query(':leave', [
      animate('300ms ease-out', style({ right: '100%' }))
    ], { optional: true }),
    query(':enter', [
      animate('300ms ease-out', style({ right: '0%' })),
    ], {optional: true})
  ]),
  query(':enter', animateChild(), {optional: true}),
];

